import React, { useState, useCallback } from 'react'
import { useRouter } from 'next/navigation'
import Image from 'next/image'
import { getBrowseCardConfigs } from '@factories/driveBrowseCardFactory'
import { Button } from '@components/Ackodrive/Button'
import assetLoader from '@utils/assetloader'
import styles from './CarNavModal.module.scss'

interface NewCarNavModalProps {
  position?: number
  onHover: (isHovering: boolean) => void
  onClose: () => void
  modalRef?: any
  filterData?: any
}

const NewCarNavModal = ({ position, onHover, onClose, modalRef, filterData }: NewCarNavModalProps) => {
  const router = useRouter()
  const [showAllBrands, setShowAllBrands] = useState<boolean>(false)

  const browseCardConfigs = getBrowseCardConfigs(filterData)

  const handleOptionClick = useCallback(
    (optionValue: string) => {
      if (optionValue === '') {
        return
      }

      router.push(`/collection/${optionValue}-cars`)
      onClose()
    },
    [router, onClose]
  )

  const getFormattedTitle = useCallback((type: string) => {
    const titleMap: Record<string, string> = {
      brand: 'Brands',
      bodyType: 'Body Type',
      fuelType: 'Fuel Type',
      transmission: 'Transmission',
      seatingCapacity: 'Seating Capacity',
      budget: 'Price Range',
    }
    return titleMap[type] || type
  }, [])

  return (
    <div
      ref={modalRef}
      className={styles.newCarNavModal}
      style={{ left: position ? `${position + 8}px` : '0' }}
      onMouseEnter={() => onHover(true)}
      onMouseLeave={() => onHover(false)}>
      <div className={styles.newCarNavInnerModal}>
        {browseCardConfigs.map((config, index) => (
          <React.Fragment key={index}>
            {config.type === 'brand' ? (
              <div className={styles.NavCard}>
                <p className={styles.NavCardTitle}>Cars by {getFormattedTitle(config.type)}</p>
                <div className={styles.options}>
                  {(showAllBrands ? config.options : config.options.slice(0, 12)).map((option, idx) => (
                    <div key={idx} className={styles.optionItem} onClick={() => handleOptionClick(option.value)}>
                      <div className={styles.optionItemImageContainer}>
                        <Image
                          src={`${assetLoader()}/icons/car-brands-light/${option.label}.svg`}
                          alt={option.label}
                          width={28}
                          height={28}
                          loading="lazy"
                        />
                      </div>
                      <p className={styles.optionItemText}>{option.label}</p>
                    </div>
                  ))}
                </div>
                {config.options.length > 12 && !showAllBrands && (
                  <Button className={styles.NavItemViewMore} onClick={() => setShowAllBrands(true)}>
                    View all brands
                    <Image
                      src={`${assetLoader()}/icons/chevron_down_light.svg`}
                      alt="view more"
                      width={20}
                      height={20}
                      loading="lazy"
                    />
                  </Button>
                )}
              </div>
            ) : (
              <div className={styles.NavCard}>
                <p className={styles.NavCardTitle}>Cars by {getFormattedTitle(config.type)}</p>
                <div className={styles.restOptions}>
                  {config.options.map((option, idx) => (
                    <Button
                      key={idx}
                      className={styles.restOptionItemText}
                      onClick={() => handleOptionClick(option.value)}>
                      {option.label}
                    </Button>
                  ))}
                </div>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

export default NewCarNavModal
